import React from 'react';
import EmailLogin from '../SignIn/SignIn';

export default function SignUp() {
  return <EmailLogin initialMode="signup" />;
}
